import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { EventsReport } from '../components/reports/EventsReport.tsx';

const EventsReportPage = () => {
  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/reports">
          Reports
        </MuiLink>
        <Typography color="text.primary">Events</Typography>
      </Breadcrumbs>
      <Typography variant="h4" gutterBottom sx={{ mt: 2 }}>
        Events Report
      </Typography>
      <EventsReport />
    </Container>
  );
};

export default EventsReportPage;
